import { render, staticRenderFns } from "./PortfolioAnalyst.vue?vue&type=template&id=4ab511dc&"
import script from "./PortfolioAnalyst.vue?vue&type=script&lang=js&"
export * from "./PortfolioAnalyst.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioAnalyst.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "packages/cb-components-portfolio-analysis/src/components/portfolioAnalyst/PortfolioAnalyst.vue"
export default component.exports